import React from 'react';
import PropTypes from 'prop-types';
import FileDownloadBase from './FileDownloadBase';

class FileDownload extends React.Component {
  static propTypes = {
    /** Classname to be applied to FileDownloadButton */
    className: PropTypes.string,
    /** If `true`, downloadButton will be Disabled */
    isDisabled: PropTypes.bool,
    /** It will show label for the fileDownloadButton */
    label: PropTypes.string,
    /** It will show label for the fileDownloadButton */
    buttonLabel: PropTypes.string,
    /** Callback function that triggers on button `onClick` */
    onRequest: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    isDisabled: false,
    label: '',
  };

  getStyles = type => {
    switch (type) {
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <FileDownloadBase styles={styles} {...otherProps} />;
  }
}
export default FileDownload;



// WEBPACK FOOTER //
// ./src/ui/library/FileDownload/FileDownload.js